import * as hrows from "../operations/hide_row_col";

export function hideColumn(column, state, page){
	hrows.setState(this, column, state, "column", page);
}
export function isColumnVisible(column, page){
	return hrows.isColumnVisible(this, column, page);
}
export function hideRow(row, state, page){
	hrows.setState(this, row, state, "row", page);
}
export function isRowVisible(row, page){
	return hrows.isRowVisible(this, row, page);
}